import { HStack, Text, Progress, VStack } from '@chakra-ui/react';
import type { NameCount } from '../../types/contactList'

export function ShareBars({ rows, color = 'blue' }: { rows: NameCount[]; color?: string }) {
  const max = Math.max(1, ...rows.map(r => r.count))
  if (rows.length === 0) return <Text fontSize="sm" color="gray.400">No data.</Text>
  return (
    <VStack align="stretch" gap={2}>
      {rows.map(r => (
        <HStack key={r.name} gap={3}>
          <Text fontSize="sm" w="130px" flexShrink={0} lineClamp={1} title={r.name}>{r.name}</Text>
          <Progress.Root
            flex="1"
            value={(r.count / max) * 100}
            size="sm"
            colorPalette={color}
            borderRadius="sm"
            aria-label={`${r.name} count`}>
            <Progress.Track>
              <Progress.Range />
            </Progress.Track>
          </Progress.Root>
          <Text fontSize="sm" w="60px" textAlign="right" fontWeight="medium">{r.count.toLocaleString()}</Text>
        </HStack>
      ))}
    </VStack>
  );
}
